import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M17 13.3c0 .5 0 1-.3 1.4-.2.5-.5.9-.8 1.2s-.8.6-1.2.8c-.5.2-.9.3-1.4.3H3.7c-1 0-1.9-.4-2.7-1.1-.6-.7-1-1.7-1-2.7V3.7c0-.5.1-1 .3-1.4.2-.5.5-.9.8-1.2S1.9.5 2.3.3c.5-.3 1-.3 1.5-.3h9.5c1 0 1.9.4 2.7 1.1.7.7 1.1 1.7 1.1 2.7v9.5ZM15.8 4c0-.4 0-.7-.2-1q-.15-.45-.6-.9-.3-.3-.9-.6c-.3-.1-.7-.2-1-.2H3.9c-.4 0-.7 0-1 .2q-.45.15-.9.6-.3.3-.6.9c-.1.3-.2.7-.2 1v9.1c0 .4 0 .7.2 1q.15.45.6.9.3.3.9.6c.3.1.7.2 1 .2h9.2c.4 0 .7 0 1-.2q.45-.15.9-.6.3-.3.6-.9c.1-.3.2-.7.2-1z" }, null, -1),
    _createElementVNode("rect", {
      width: "8.3",
      height: "1.3",
      x: "4.5",
      y: "8",
      rx: ".6",
      ry: ".6"
    }, null, -1),
    _createElementVNode("rect", {
      width: "1.3",
      height: "8.3",
      x: "8",
      y: "4.5",
      rx: ".6",
      ry: ".6"
    }, null, -1)
  ]))]))
}
export default { render: render }